import { useState } from 'react';

export default function FAQSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => setOpenFaq(openFaq === index ? null : index);

  const faqs = [
    {
      question: 'Вы как тренер сами звоните на тренинге в качестве примера?',
      answer: 'Да, я регулярно делаю живые звонки на тренинге. Это ключевой элемент обучения: участники видят, как работает методика в реальном разговоре, слышат живую реакцию собеседника, наблюдают за интонацией и темпом. После звонка мы вместе разбираем: что сработало, какие приёмы использовались, как реагировал клиент. Никакой теории — только реальная практика перед глазами группы.',
    },
    {
      question: 'Почему холодные звонки до сих пор работают?',
      answer: 'Холодные звонки остаются одним из самых эффективных каналов прямых продаж B2B, потому что позволяют быстро установить личный контакт с ЛПР, выявить потребность и договориться о встрече. В отличие от email-рассылок и рекламы, звонок даёт немедленную обратную связь. При правильном подходе — без давления и агрессивных скриптов — холодный звонок превращается в профессиональную деловую коммуникацию, которая открывает возможности для долгосрочного сотрудничества.',
    },
    {
      question: 'Подходит ли программа для B2B?',
      answer: 'Да, программа специально разработана для B2B-продаж. Мы учим выходить на ЛПР в крупных и средних компаниях, проходить секретарей и ассистентов, формулировать ценность для бизнес-аудитории и назначать встречи с лицами, принимающими решения. Все кейсы и практические задания строятся на реальных B2B-сценариях из вашей отрасли.',
    },
    {
      question: 'Можно ли обучать опытных менеджеров?',
      answer: 'Да, опытные менеджеры часто получают наибольшую пользу от обучения. У них уже есть база реальных ситуаций для разбора, и мы выявляем скрытые неэффективные привычки, которые накопились за годы работы, усиливаем сильные стороны и помогаем выйти на новый уровень конверсии. Программа адаптируется под уровень каждого участника.',
    },
    {
      question: 'Используются ли реальные звонки сотрудников?',
      answer: 'Да, это основа программы. Мы прослушиваем реальные записи звонков ваших менеджеров, анализируем их и разбираем на тренинге: что сработало, что потеряли, как усилить. Участники работают со своими настоящими клиентами и сценариями — это повышает вовлечённость в десятки раз и позволяет сразу применить новые навыки в знакомых ситуациях.',
    },
    {
      question: 'Можно ли адаптировать программу под нашу отрасль?',
      answer: 'Да, каждая программа адаптируется под конкретную отрасль, продукт, рынок и цикл сделки компании. Мы используем реальные кейсы, возражения и сценарии из вашей практики. Никаких универсальных скриптов — только то, что работает в вашем сегменте и с вашими клиентами.',
    },
    {
      question: 'Есть ли сопровождение после тренинга?',
      answer: 'Да, сопровождение — ключевой элемент, который отличает наши программы. После основного тренинга мы продолжаем работу: разбираем новые звонки, корректируем стратегию, поддерживаем в чате, помогаем внедрять регламенты и Книгу продаж. Именно сопровождение обеспечивает закрепление навыков и устойчивый рост показателей.',
    },
    {
      question: 'Через сколько появляются первые результаты?',
      answer: 'Первые изменения в поведении менеджеров — уверенность, качество диалога, снижение страха — видны уже после первого тренингового дня. Измеримые бизнес-результаты: рост конверсии, увеличение количества назначенных встреч, сокращение цикла сделки — обычно проявляются через 2–4 недели после обучения при условии активного внедрения и сопровождения.',
    },
    {
      question: 'Можно ли провести обучение онлайн?',
      answer: 'Да, тренинг по холодным звонкам полностью доступен в онлайн-формате. Мы проводим живые сессии с отработкой звонков через видеосвязь, ролевые переговоры, детальный разбор реальных кейсов и записей разговоров. Онлайн-формат полностью сохраняет практическую направленность и эффективность обучения, не уступая очному.',
    },
    {
      question: 'Сколько длится обучение?',
      answer: 'Форматы варьируются: интенсивный тренинг — 1–2 полных дня, модульная программа — от 2 недель до 2 месяцев, комплексная программа с сопровождением — 3–6 месяцев. Точная продолжительность определяется после диагностики текущего уровня команды и поставленных бизнес-целей.',
    },
    {
      question: 'Как измеряется эффективность обучения?',
      answer: 'Мы используем несколько уровней оценки: прослушивание звонков до и после обучения, анализ CRM-показателей (конверсия, количество встреч, цикл сделки), обратная связь от руководителя и самих участников. Через 1–3 месяца после обучения проводим контрольный аудит и при необходимости корректируем стратегию.',
    },
  ];

  return (
    <section id="faq" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ответы на самые популярные вопросы о корпоративном обучении холодным звонкам.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-base md:text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  {openFaq === index ? (
                    <i className="ri-arrow-up-s-line text-teal-600"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-teal-600"></i>
                  )}
                </div>
              </button>
              <div className={`px-6 pb-6 ${openFaq === index ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}